import React from "react";
import { useState } from "react";
// import lo_mejor_de_mi from "/assets/songs/besos.mp3";
// import me_voy from "../../assets/songs/Andres_CepedaMe_Voy.mp3";
// import besos_usados from "../../assets/songs/Besos_Usados.mp3";
// import tengo_ganas from "../../assets/songs/Tengo_Ganas_Andres_Cepeda.mp3";
import { useNavigate } from "react-router-dom";

const SongSelectVideoTwo = ({ setSongSelected }) => {
  const [songOnePlay, setSongOnePlay] = useState(false);
  const [songTwoPlay, setSongTwoPlay] = useState(false);
  const [songThreePlay, setSongThreePlay] = useState(false);
  const [songFourPlay, setSongFourPlay] = useState(false);
  const [songFivePlay, setSongFivePlay] = useState(false);
  const navigate = useNavigate();

  const changePage = () => {
    const anims_left = document.querySelector(".anim_slider");
    anims_left.classList.remove("animate__bounceInRight");
    anims_left.classList.add("animate__bounceOutLeft");

    setTimeout(() => {
      navigate("/textos-video-dos");
    }, 1000);
  };

  const changePagePrev = () => {
    const anims_left = document.querySelector(".anim_slider");
    anims_left.classList.remove("animate__bounceInRight");
    anims_left.classList.add("animate__bounceOutLeft");
    setTimeout(() => {
      navigate("/formulario");
    }, 1000);
  };

  return (
    <div className="select_song">
      <div className="select_song_container containerAll anim_slider animate__animated animate__bounceInRight">
        <h1 className="title">GALERÍA MUSICALIZADA</h1>
        <div className="content_steps">
          <div className="content_circles">
            <div onClick={changePagePrev} className="circle pointer"></div>
            <div className="circle"></div>
            <div className="circle"></div>
          </div>
          <h2> Paso 2 de 3</h2>
        </div>

        <p>Selecciona la canción de Cantirondas que quieres usar de fondo</p>

        <div className="capsules_songs">
          <div className="capsule_song">
            <h1
              onClick={() => {
                setSongSelected("/songs/Solsolecito.mp3");
                changePage();
              }}
            >
              Sol Solecito
            </h1>

            {!songOnePlay ? (
              <img
                onClick={() => {
                  setSongOnePlay(true);
                  setSongTwoPlay(false);
                  setSongThreePlay(false);
                  setSongFourPlay(false);
                  setSongFivePlay(false);
                  document.getElementById("s5").pause();
                  document.getElementById("s1").play();
                  document.getElementById("s2").pause();
                  document.getElementById("s3").pause();
                  document.getElementById("s4").pause();
                }}
                src="/assets/play.png"
                alt="play"
              />
            ) : (
              <img
                onClick={() => {
                  setSongOnePlay(false);
                  document.getElementById("s1").pause();
                }}
                src="/assets/pausa.png"
                alt="play"
              />
            )}
            <audio id="s1" src="/songs/Solsolecito.mp3"></audio>
          </div>
          <div className="capsule_song">
            <h1
              onClick={() => {
                setSongSelected("/songs/heladero.mp3");
                changePage();
              }}
            >
              Sammy el Heladero
            </h1>
            {!songTwoPlay ? (
              <img
                onClick={() => {
                  setSongTwoPlay(true);
                  setSongOnePlay(false);
                  setSongThreePlay(false);
                  setSongFourPlay(false);
                  setSongFivePlay(false);
                  document.getElementById("s5").pause();
                  document.getElementById("s2").play();
                  document.getElementById("s1").pause();
                  document.getElementById("s3").pause();
                  document.getElementById("s4").pause();
                }}
                src="/assets/play.png"
                alt="play"
              />
            ) : (
              <img
                onClick={() => {
                  setSongTwoPlay(false);
                  document.getElementById("s2").pause();
                }}
                src="/assets/pausa.png"
                alt="play"
              />
            )}
            <audio id="s2" src="/songs/heladero.mp3"></audio>
          </div>
          <div className="capsule_song">
            <h1
              onClick={() => {
                setSongSelected("/songs/pollitos.mp3");
                changePage();
              }}
            >
              Los Pollitos Dicen
            </h1>
            {!songThreePlay ? (
              <img
                onClick={() => {
                  setSongTwoPlay(false);
                  setSongOnePlay(false);
                  setSongThreePlay(true);
                  setSongFourPlay(false);
                  setSongFivePlay(false);
                  document.getElementById("s5").pause();
                  document.getElementById("s3").play();
                  document.getElementById("s1").pause();
                  document.getElementById("s2").pause();
                  document.getElementById("s4").pause();
                }}
                src="/assets/play.png"
                alt="play"
              />
            ) : (
              <img
                onClick={() => {
                  setSongThreePlay(false);
                  document.getElementById("s3").pause();
                }}
                src="/assets/pausa.png"
                alt="play"
              />
            )}
            <audio id="s3" src="/songs/pollitos.mp3"></audio>
          </div>
          <div className="capsule_song">
            <h1
              onClick={() => {
                setSongSelected("/songs/pinpon.mp3");
                changePage();
              }}
            >
              Pin Pon
            </h1>
            {!songFourPlay ? (
              <img
                onClick={() => {
                  setSongTwoPlay(false);
                  setSongOnePlay(false);
                  setSongThreePlay(false);
                  setSongFourPlay(true);
                  setSongFivePlay(false);
                  document.getElementById("s5").pause();
                  document.getElementById("s4").play();
                  document.getElementById("s1").pause();
                  document.getElementById("s2").pause();
                  document.getElementById("s3").pause();
                }}
                src="/assets/play.png"
                alt="play"
              />
            ) : (
              <img
                onClick={() => {
                  setSongFourPlay(false);
                  document.getElementById("s4").pause();
                }}
                src="/assets/pausa.png"
                alt="play"
              />
            )}
            <audio id="s4" src="/songs/pinpon.mp3"></audio>
          </div>

          <div className="capsule_song">
            <h1
              onClick={() => {
                setSongSelected("/songs/aplaudir.mp3");
                changePage();
              }}
            >
              Ganas De Aplaudir
            </h1>
            {!songFivePlay ? (
              <img
                onClick={() => {
                  setSongTwoPlay(false);
                  setSongOnePlay(false);
                  setSongThreePlay(false);
                  setSongFourPlay(false);
                  setSongFivePlay(true);
                  document.getElementById("s4").pause();
                  document.getElementById("s1").pause();
                  document.getElementById("s2").pause();
                  document.getElementById("s3").pause();
                  document.getElementById("s5").play();
                }}
                src="/assets/play.png"
                alt="play"
              />
            ) : (
              <img
                onClick={() => {
                  setSongFivePlay(false);
                  document.getElementById("s5").pause();
                }}
                src="/assets/pausa.png"
                alt="play"
              />
            )}
            <audio id="s5" src="/songs/aplaudir.mp3"></audio>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SongSelectVideoTwo;
